import CampCoachesIndex from './CampCoachesIndex';
import CampCoachesCreate from './CampCoachesCreate';
import CampCoachesSettings from './CampCoachesSettings';
import CampCoachesSingle from './CampCoachesSingle';

export default function (app) {

    const settings = CampCoachesSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    CampCoachesIndex(app, settings);

    CampCoachesCreate(app, settings);

    CampCoachesSingle(app, settings);

}